import { LandingPoposedToTheSubCommitteeComponent } from "../../../components/borrowSystem/ProposedToTheSubCommittee/LandingPoposedToTheSubCommitteeComponent";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function LandingPoposedToTheSubCommitteeContainer () {
    const titleName =
    "แบบเสนอคณะอนุกรรมการ"; //ใส่ชื่อtitle ตรงนี้
    
    return(
        <div className="page-container bg-landing">
            <NavbarBorrowSystem/>
            <HeadTitle title={titleName} />
            <LandingPoposedToTheSubCommitteeComponent/>
            <Footer />
        </div>

    )
}




